const setAuth = (user = null) => {
    // set user to localstorage
    if (user) {
      localStorage.setItem("token-2", JSON.stringify(user));
    } else {
      localStorage.removeItem();
    }
  };
  
  const getAuth = () => {
    // set user to localstorage
    let user = localStorage.getItem("token-2");
    if (user) {
      return JSON.parse(user);
    }
    return null;
  };
  
  export default {
    setAuth,
    getAuth,
  };
  